import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading2,
  Paragraph,
  List,
  Bold,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Craft">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Craft Beer</Heading1>
        </Col>
        <Col md={12} paddingTop="0px">
          <Paragraph>
            Craft beer på fad er som at hælde et godt special håndværk i glasset. Her på siden finder du vores udvalg af håndbrygget øl fra mindre bryghuse, de såkaldte mikrobryggerier. Der er kælet for detaljerne og det gode håndværk, når du nyder en craft beer. Hos Skafte finder du udsøgt craft beer fra bl.a. Kissmeyer, To Øl og Schiøtz, der alle er garanti for en lækker craft beer oplevelse.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelCraftBeer" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvad er craft beer?</Heading2>
          <Paragraph>
            Craft beer adskiller sig fra det ellers velkendte, men ofte masseproducerede øl. De store ølmærker leverer mange gode øl, der passer til forskellige lejligheder og altid kan nydes. Craft beer leveres derimod fra mindre bryggerier, der ikke har en ligeså stor markedsandel, som de velkendte ølmærker som fx Tuborg, Carlsberg, Heineken osv.
            Craft beer er også tidligere blevet betegnet som øl fra mikrobryggerier, men begrebet “mikrobryg” bruges ikke så meget længere og er efterhånden blevet erstattet med begrebet “craft beer”.
          </Paragraph>
          <Paragraph>
            Craft beer kan oversættes løst til “håndværks øl”, hvilket dækker meget godt over de smagfulde dråber. Meget håndbrygget øl er et oprør med den ellers så konservative brygmetode, der ses og smages hos de store bryghuse, men søger derimod efter enten nyskabelse, gamle traditioner, autencitet og naturligvis håndværket ved ølbrygning.
            Når der er tale om craft beer, bliver der ofte slået på den gastronomiske begivenhed, da øllet fylder munden med helt nye oplevelser.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>4 grunde til at du skal vælge en craft beer på fad</Heading2>
          <Paragraph>
            Craft beer på fad giver en unik smagsoplevelse, og overrasker smagsløgene på allerbedste vis! Denne ølgenre er som oftest skabt med passion og nysgerrighed, hvilket kan smages, når du inviteres indenfor i et rent kalejdoskop af smag, der er med til at tage festen eller arrangementet til nye højder.
          </Paragraph>
          <Paragraph>
            Er du stadig ikke helt solgt? Her får du 4 grunde til at vælge en skøn craft beer på fad
          </Paragraph>
          <List ordered>
            <li>
              <Bold>Smagsnuancer</Bold><br />
              Craft beer er ikke bare én ting. Det er et væld af smage og aromaer, der byder på alt lige fra de tropisk frugtagtige toner i en IPA til den dybe, maltede smag af en ristet stout. Måske finder du noter af kaffe, karamel, citrus, gran, bær eller endda eksotiske krydderier. Med craft beer er hver øl en ny overraskelse.
            </li>
            <li>
              <Bold>Kan nydes alene eller til mange forskellige retter</Bold><br />
              Det er en absolut god oplevelse at nyde en craft beer alene, men den er en uovertruffen ledsager til mad. En frisk og sprød IPA kan for eksempel skære igennem fedmen i en lækker burger, mens en mørk og kompleks ale kan forstærke og komplementere den søde smag i en chokoladebrownie. Mulighederne er nærmest uendelige, da hver øl har sin unikke smagsprofil.
            </li>
            <li>
              <Bold>Mange forskellige varianter</Bold><br />
              Når der er tale om håndbrygget øl, er der samtidig også tale om mange forskellige varianter. Du kan derfor vælge alt mellem en IPA, lys ale, mørk ale mm., når du vælger en craft beer.
            </li>
            <li>
              <Bold>Noget for enhver smag</Bold><br />
              Mens mainstream øl ofte brygges i store mængder med fokus på ensartethed og bred appel, er craft beer kendt for sin eksperimenterende natur og individuelle karakter. Bryggerierne bag disse øl tager ofte kreative friheder, som resulterer i unikke og spændende smagskombinationer.
            </li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Craft beer - dansk og dejligt</Heading2>
          <Paragraph>
            Det kan være svært at vælge fra vores lækre udvalg af craft beer på fad, da hver enkelte øl byder på hver sin egen smagfulde oplevelse.
          </Paragraph>
          <Paragraph>
            Blandt Skaftes sortiment af craft beer finder du disse fra danske bryggerier:
          </Paragraph>
          <List>
            <li><Bold>Kissmeyer Garage Eagle Kiss: </Bold>denne craft beer er en session IPA, der på den ene side har stor respekt for traditioner og gamle dyder, men på den anden side har et personligt twist fra bryghuset, der får den til at adskille sig fra andre IPA øl. En let, tør og sprød craft beer med en masse frugtig humle.</li>

            <li><Bold>Kissmeyer Icons Stockholm Syndrome: </Bold>craft beer i form af en dobbelt imperial IPA. Øllen er en hilsen til tidligere ikoniske øl fra bryghuset og byder på en intens og fyldig smag, med en balanceret bitterhed samt en vinøs eftersmag.</li>

            <li><Bold>Kissmeyer Icons Into The Black: </Bold>sort IPA craft beer og er ligeledes en hilsen til en tidligere ikonisk øl fra bryghuset. Denne craft beer har masser af humle samt en mild ristet maltsmag og en markant, men glat bitterhed.</li>

            <li><Bold>Kissmeyer Garage Burning Kiss: </Bold>amber ale craft beer, der på én og samme tid byder på stor respekt for de gamle traditioner, men samtidig byder på et nyt twist. Sprød fadøl med mild malt og humle samt en skøn harmoni.</li>

            <li><Bold>Kissmeyer Garage Easy Kiss: </Bold>pale ale craft beer med maltet og frugtige karakterer samt en glat og harmonisk fylde. Kissmeyer Icons Young Lust: craft beer af typen belgian blonde, der byder på en aromatisk og krydret aroma med en både sød og salt smag samt en nordisk tilføjelse af urter.</li>

            <li><Bold>Kissmeyer Garage Eclipsed Kiss: </Bold>en American style stout craft beer, der har en intens sort farve samt en fyldig og humlet smag.
              To Øl Mr. Orange: en session IPA med noter af citrus. En forfriskende craft beer.
            </li>

            <li><Bold>Schiøtz Mørk Mumme: </Bold>kraftig, mørk og maltet craft beer med et strejf af nordiske bær, der giver en kompleks og spændende smagsoplevelse.</li>
          </List>
          <Paragraph>
            Når craft beer er dansk, kan du være sikker på en uovertruffen smagsoplevelse, uanset hvilken du vælger.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Håndbrygget øl der er udover det sædvanlige</Heading2>
          <Paragraph>
            Hos Skafte har vi udvalgt nogle af de ypperste craft beers på fad, der er brygget med stor respekt for smagen, men samtidig byder på eksperimenterende og nytænkende noter, metoder og smagsindtryk.
          </Paragraph>
          <Paragraph>
            Vi sørger for hurtig levering på kun 1-2 dage i almindelig arbejdstid, så du er godt klædt på til festen.
          </Paragraph>
          <Paragraph>
            Der er kælet for detaljerne og det gode håndværk, hvilket kan duftes og smages, når du lader den kolde kærlighed varme om sjælen. Håndbrygget øl skal opleves - og du finder det selvfølgelig på fad hos Skafte.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
